import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Radio } from 'react-bootstrap';

import MultiFoodNIP from './MultiFoodNIP';
import MultiFoodBasic from './MultiFoodBasic';
import MultiFoodFullAlphabetical from './MultiFoodFullAlphabetical';
import MultiFoodFullGrouped from './MultiFoodFullGrouped';
import { componentSets, empty_key_message} from '../../util/util';

import Buttons from '../../util/Buttons';

import './MultiFoodResult.css';

class MultiFoodResult extends Component {
  constructor(props) {
    super(props);
    this.state = {
      csvHeader: [],
      csvData: [],
    };
    this.setCsvHeader = this.setCsvHeader.bind(this);
    this.setCsvData = this.setCsvData.bind(this);
  }

  setCsvHeader(header) {
    this.setState({csvHeader: header});
  }

  setCsvData(newCsvData) {
    this.setState({csvData: newCsvData});
  }

  render() {
    const { selectedFoods, selectedReport, per100g, handlePerChange } = this.props;

    // CSV configuration
    const csvFoodNames = selectedFoods.map((food, i) => {
      return `${i + 1}) ` + (food.shortname.length > 30
        ? food.shortname.slice(0, 27) + '...'
        : food.shortname)
      + `(${food.recordid})`;
    }).join(' ');
    const csvPerServe = per100g ? 'per100g' : 'perServe';
    const csvFilename = `Multi-food Search Result--${csvFoodNames}--${csvPerServe}--${selectedReport}.csv`;

    return (
      <div className="MultiFoodResult">

        <Buttons
          csvHeader={this.state.csvHeader}
          csvData={this.state.csvData}
          filename={csvFilename}
        />

        <div className='showsTotal'>
          <span>Comparison of foods on a</span>
          <form>
            <FormGroup>
              <Radio inline name='base'
                checked={!per100g}
                onChange={() => handlePerChange(false)}
              >
                per serve
              </Radio>
              <Radio inline name='base'
                checked={per100g}
                onChange={() => handlePerChange(true)}
              >
                per 100 g
              </Radio>
              <span> basis.</span>
            </FormGroup>
          </form>
          <div>{ empty_key_message }</div>
        </div>

        {selectedReport === componentSets[0].key &&
          <MultiFoodNIP
            selectedFoods={selectedFoods}
            per100g={per100g}
            setCsvHeader={this.setCsvHeader}
            setCsvData={this.setCsvData}
          />
        }

        {selectedReport === componentSets[2].key &&
          <MultiFoodBasic
            selectedFoods={selectedFoods}
            selectedReport={selectedReport}
            per100g={per100g}
            setCsvHeader={this.setCsvHeader}
            setCsvData={this.setCsvData}
          />
        }

        {selectedReport === componentSets[3].key &&
          <MultiFoodFullAlphabetical
            selectedFoods={selectedFoods}
            selectedReport={selectedReport}
            per100g={per100g}
            setCsvHeader={this.setCsvHeader}
            setCsvData={this.setCsvData}
          />
        }

        {selectedReport === componentSets[4].key &&
          <MultiFoodFullGrouped
            selectedFoods={selectedFoods}
            selectedReport={selectedReport}
            per100g={per100g}
            setCsvHeader={this.setCsvHeader}
            setCsvData={this.setCsvData}
          />
        }

      </div>
    );
  }
}

MultiFoodResult.propTypes = {
  selectedFoods: PropTypes.array,
  selectedReport: PropTypes.string,
  per100g: PropTypes.bool.isRequired,
  handlePerChange: PropTypes.func.isRequired,
};

export default MultiFoodResult;



// WEBPACK FOOTER //
// ./src/components/search/multiFood/MultiFoodResult.js